import { createSlice } from "@reduxjs/toolkit";
import {
  fetcCharityAddressList,
  fetchHomeAddressList,
  fetchPickupAddressList,
  getAvailableCities,
  getAvailableStates,
} from "../thunk/addressThunk";

const initialState = {
  pickupList: [],
  homeList: [],
  charityList: [],
  pickupLoading: false,
  homeLoading: false,
  charityLoading: false,
  pickupError: null,
  homeError: null,
  charityError: null,
  availableCities: null,
  availableCitiesLoading: true,
  availableCitiesError: null,
  availableStates: null,
  availableStatesLoading: true,
  availableStatesError: null,
};
const addressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPickupAddressList.pending, (state) => {
        state.pickupLoading = true;
        state.pickupError = null;
      })
      .addCase(fetchPickupAddressList.fulfilled, (state, action) => {
        state.pickupLoading = false;
        state.pickupList = action.payload.data;
      })
      .addCase(fetchPickupAddressList.rejected, (state, action) => {
        state.pickupLoading = false;
        state.pickupError = action.payload;
      })
      //
      .addCase(fetchHomeAddressList.pending, (state) => {
        state.homeLoading = true;
        state.homeError = null;
      })
      .addCase(fetchHomeAddressList.fulfilled, (state, action) => {
        state.homeLoading = false;
        state.homeList = action.payload.data;
      })
      .addCase(fetchHomeAddressList.rejected, (state, action) => {
        state.homeLoading = false;
        state.homeError = action.payload;
      })
      //
      .addCase(fetcCharityAddressList.pending, (state) => {
        state.charityLoading = true;
        state.charityError = null;
      })
      .addCase(fetcCharityAddressList.fulfilled, (state, action) => {
        state.charityLoading = false;
        state.charityList = action.payload.data;
      })
      .addCase(fetcCharityAddressList.rejected, (state, action) => {
        state.charityLoading = false;
        state.charityError = action.payload;
      })
      // Get available city
      .addCase(getAvailableCities.pending, (state) => {
        state.availableCitiesLoading = true;
        state.availableCitiesError = null;
      })
      .addCase(getAvailableCities.fulfilled, (state, action) => {
        state.availableCitiesLoading = false;
        state.availableCities = action?.payload?.cities;
      })
      .addCase(getAvailableCities.rejected, (state, action) => {
        state.availableCitiesLoading = false;
        state.availableCitiesError = action.payload;
      })
       // Get available States
      .addCase(getAvailableStates.pending, (state) => {
        state.availableStatesLoading = true;
        state.availableStatesError = null;
      })
      .addCase(getAvailableStates.fulfilled, (state, action) => {
        state.availableStatesLoading = false;
        state.availableStates = action?.payload?.message;
      })
      .addCase(getAvailableStates.rejected, (state, action) => {
        state.availableStatesLoading = false;
        state.availableStatesError = action.payload;
      });
  },
});

export default addressSlice.reducer;
